import { gql, type TypedDocumentNode } from "@apollo/client";
import type { CommissionProgramConsentNode } from "./types";

export interface CreateCommissionProgramConsentInput {
  commissionCampaignId: string;
  crmPersonId: string;
  attributionModel: CommissionProgramConsentNode["attributionModel"];
  ownership?: CommissionProgramConsentNode["ownership"];
  startsAt: string;
  endsAt?: string | null;
  status: CommissionProgramConsentNode["status"];
}

export interface UpdateCommissionProgramConsentInput {
  id: string;
  attributionModel?: CommissionProgramConsentNode["attributionModel"];
  ownership?: CommissionProgramConsentNode["ownership"];
  startsAt?: string;
  endsAt?: string | null;
  status?: CommissionProgramConsentNode["status"];
}

export const CREATE_COMMISSION_PROGRAM_CONSENT_MUTATION: TypedDocumentNode<
  { commissionCreateProgramConsent: { consent: CommissionProgramConsentNode } },
  { input: CreateCommissionProgramConsentInput }
> = gql`
  mutation CreateCommissionProgramConsent($input: CreateCommissionProgramConsentInput!) {
    commissionCreateProgramConsent(input: $input) {
      consent {
        id
        commissionCampaignId
        crmPersonId
        attributionModel
        ownership
        startsAt
        endsAt
        status
      }
    }
  }
`;

export const UPDATE_COMMISSION_PROGRAM_CONSENT_MUTATION: TypedDocumentNode<
  { commissionUpdateProgramConsent: { consent: CommissionProgramConsentNode } },
  { input: UpdateCommissionProgramConsentInput }
> = gql`
  mutation UpdateCommissionProgramConsent($input: UpdateCommissionProgramConsentInput!) {
    commissionUpdateProgramConsent(input: $input) {
      consent {
        id
        commissionCampaignId
        crmPersonId
        attributionModel
        ownership
        startsAt
        endsAt
        status
      }
    }
  }
`;
